type Result = {
  nContacts: number;
  nInvalid: number;
  nDuplicates: number;
  nNeedingClicks: number;
  nOptOuts: number;
  nExcludedByVan?: number;
};

export default function JobResult({ result }: { result: Result }): JSX.Element {
  const nRemoved =
    result.nInvalid +
    result.nDuplicates +
    result.nOptOuts +
    (result.nExcludedByVan ?? 0);

  return (
    <ul>
      <li>
        <strong>{result.nContacts.toLocaleString()} valid contacts</strong>
      </li>
      <li>
        {result.nNeedingClicks.toLocaleString()} need to be loaded in the
        clicker
      </li>
      {nRemoved > 0 ? (
        <li>
          {nRemoved.toLocaleString()} contacts were skipped
          <ul>
            {result.nInvalid ? (
              <li>
                {result.nInvalid === 1
                  ? "1 contact"
                  : `${result.nInvalid.toLocaleString()} contacts`}{" "}
                skipped due to invalid phone numbers
              </li>
            ) : null}
            {result.nDuplicates ? (
              <li>
                {result.nDuplicates === 1
                  ? "1 duplicate"
                  : `${result.nDuplicates.toLocaleString()} duplicates`}{" "}
                skipped
              </li>
            ) : null}
            {result.nOptOuts ? (
              <li>
                {result.nOptOuts === 1
                  ? "1 opted-out contact"
                  : `${result.nOptOuts.toLocaleString()} opted-out contacts`}
              </li>
            ) : null}
            {result.nExcludedByVan ? (
              <li>
                {result.nExcludedByVan === 1
                  ? "1 contact excluded by VAN"
                  : `${result.nExcludedByVan.toLocaleString()} contacts excluded by VAN`}
              </li>
            ) : null}
          </ul>
        </li>
      ) : null}
    </ul>
  );
}
